
// 报表页
const statement = () => import(/* webpackChunkName: "Index" */ '@/views/statementModule/index')

const livestatementList = () => import(/* webpackChunkName: "Index" */ '@/views/statementModule/livestatementList')
const anchorAttendance = () => import(/* webpackChunkName: "Index" */ '@/views/statementModule/anchorAttendance');// 主播数据
const anchorAttendancePunch = () => import(/* webpackChunkName: "Index" */ '@/views/anchorAttendancePunch/anchorAttendance.vue');// 主播数据打卡
const assistantDirectorData = () => import(/* webpackChunkName: "Index" */ '@/views/matchAreaController/assistantDirectorData/anchorAttendance.vue');// 副播数据
const viedoLivestatementList = () => import(/* webpackChunkName: "Index" */ '@/views/statementModule/viedoLivestatementList')
const livestatementKsList = () => import(/* webpackChunkName: "Index" */ '@/views/statementModule/livestatementKsList')
const streamerSettlementList = () => import(/* webpackChunkName: "Index" */ '@/views/statementModule/streamerSettlementList')


const statementRouter = [
    {
      path: '/index',
      redirect: '/admin/home',
      component: () => import('@/views/loginModule/index'),
      children: [
        {
          path: '/admin/statement',
          name: 'statement',
          component: statement,
          meta: {
            title: '报表'
          },
          redirect: '/admin/statement/livestatementList',
          children: [
            {
              path: '/admin/statement/livestatementList',
              name: 'livestatementList',
              component: livestatementList,
              meta: {
                title: '报表'
              },
            },
            {
              path: '/admin/statement/viedoLivestatementList',
              name: 'viedoLivestatementList',
              component: viedoLivestatementList,
              meta: {
                title: '报表'
              },
            },
            {
              path: '/admin/statement/livestatementKsList',
              name: 'livestatementKsList',
              component: livestatementKsList,
              meta: {
                title: '报表'
              },
            },
            {
              path: '/admin/statement/anchorAttendance',
              name: 'anchorAttendance',
              component: anchorAttendance,
              meta: {
                title: '主播数据人脸'
              },
            },
            {
              path: '/admin/statement/anchorAttendancePunch',
              name: 'anchorAttendancePunch',
              component: anchorAttendancePunch,
              meta: {
                title: '主播数据打卡'
              },
            },
            {
              path: '/admin/statement/assistantDirectorData',
              name: 'assistantDirectorData',
              component: assistantDirectorData,
              meta: {
                title: '副播数据'
              },
            },
            {
              path: '/admin/statement/streamerSettlementList',
              name: 'streamerSettlementList',
              component: streamerSettlementList,
              meta: {
                title: '结算报表'
              },
            }
          ]
        }
      ]
    }
  ]
  export default statementRouter

